import SubscribeEmail from './SubscribeEmail'

export default SubscribeEmail
